import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'

type SimpleTextWithIconCardProps = {
  title: string
  description: string
  icon: string
}

const Wrapper = styled(Row)`
  & h3 {
    font-size: 0.8rem;
    line-height: 0.5rem;
  }
  & p {
    line-height: 0.5rem;
  }
`

const IconContainer = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SimpleTextWithIconCard = ({ icon, title, description }: SimpleTextWithIconCardProps) => {
  return (
    <Wrapper>
      <IconContainer xs={3}>
        <img src={icon} width="48" alt='' />
      </IconContainer>
      <Col>
        <Row>
          <Col xs={12}>
            <h3>
              {title}
            </h3>
          </Col>
          <Col xs={12}>
            <p>
              {description }
            </p>
          </Col>
        </Row>
      </Col>
    </Wrapper>
  )
}